<div class="overflow-hidden pos-relative z-2">
    <div class="_wrapper _hidden"
         [toggleClass]="'!_hidden'"
         [toggleClassBy]="toggleGroupId"
         [elementHeight]="'meganav'">

        <!-- standard meganav -->
        @for (item of content?.meganav; track $index) {
        <div class="_area custom-scrollbar bg-col-w"
             pageHeaderMeganavContentArea
             [toggleClass]="'!_hidden'"
             [toggleClassBy]="[toggleGroupId, $index]">
            <icms-component class="wrap _content block"
                            (mouseenter)="onMouseIn($index)"
                            (mouseleave)="onMouseOut($index)"
                            [data]="getItemWithId(item)" />
        </div>
        }

        <!-- search outlet -->
        <div class="_area custom-scrollbar bg-col-w"
             pageHeaderMeganavContentArea
             [toggleClass]="'!_hidden'"
             [toggleClassBy]="[toggleGroupId, searchMeganavKey]">
            <div class="wrap p-t-10 p-b-10 _content"
                 pageHeaderMeganavSearchOutlet>
                <page-search-outlet />
            </div>
        </div>
    </div>
</div>


<!-- overlay -->
<overlay [visible]="toggleService.getState(toggleGroupId)"
         class="z-1" />